import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {OphDrawerService} from './oph-drawer.service';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'oph-drawer',
  templateUrl: './oph-drawer.component.html',
  styleUrls: ['./oph-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphDrawerComponent implements OnInit, OnDestroy {
  @ViewChild('drawerContent', {read: ViewContainerRef, static: true}) drawerContent!: ViewContainerRef;
  @Output() drawerClose = new EventEmitter<void>();
  drawerService = inject(OphDrawerService);
  drawerContext = this.drawerService.getDrawerContext();
  unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.subscribeDrawerContext();
    this.drawerService.setDrawerContent(this.drawerContent);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.drawerService.closeDrawer();
  }

  subscribeDrawerContext(): void {
    this.drawerService.drawerContext$.pipe(takeUntil(this.unsubscribe$)).subscribe(context => {
      this.drawerContext = context;
    });
  }

  get hideCloseButton(): boolean {
    return this.drawerContext?.hideCloseButton || true;
  }

  get hideBackdrop(): boolean {
    return this.drawerContext?.hideBackdrop || false;
  }

  get hideScrollbar(): boolean {
    return this.drawerContext?.hideScrollbar || false;
  }

  get isVisible$() {
    return this.drawerService.visible$;
  }

  openDrawer(): void {
    this.drawerService.openDrawer();
  }

  closeDrawer(): void {
    this.drawerService.closeDrawer();
    this.drawerClose.emit();
  }

  loadComponent<T>(component: Type<T>): void {
    this.drawerService.loadComponent(component);
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape' && this.drawerService.isDrawerVisible()) {
      this.closeDrawer();
    }
  }
}
